import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import {FlyerDto, FlyerPageDto, ItemsListMenuDto, UserDto} from "../../../../../dtos";
import moment from "moment";
import '../../flyer.scss'
import {ReactComponent as AnalyticsIcon} from "./../../../../../assets/flyersScreen/analitics_icon_blue.svg";
import {hideMenu} from "react-contextmenu/modules/actions";

import {
    dispatchEventDataType, EVENT_DATA_TYPE_CREAT_NEW_FLYER
} from '../../../../../globals/EventDispatcher'
import {FlyersStateDto} from "../flyersCatalog";
import {Box, Button, Grid, Popover, Typography, useMediaQuery} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {AsyncImageWithLoader} from "../../../../../com/imageWithLoader/imageWithLoader";
import {AnalyticsPopup} from "../../../../../com/analyticsPopup/analyticsPopup";
import envManager from "../../../../../com/envManager/EnvManager";
import StatusPopup, {StatusPopupType} from "../../../../../com/statusPopup/StatusPopup";
import {getSettingsForPopup} from "../../../pages/getSetttingsForPopup";
import {useDispatch} from "react-redux";
import {useTypedSelector} from "../../../../../hooks/useTypeSelector";
import {
    MenuForPromotion
} from "../../../promos/leftMenu/LeftMenuContent/LeftMenuContentElement/MenuForPromotions/menuForPromotions";
import {ReactComponent as MenuOnHover} from "../../../../../assets/flyersScreen/3_dots_icon.svg";
import {useDoubleTap} from "use-double-tap";
import {history} from '../../../../../helpers/history';
import {
    startUploadingImagesProgressPopup
} from "../../../../../store/actionCreators/uploadingImagesProgressActionCreator";
import {uploadImagesToPages} from "../../../../../store/actionCreators/pagesActionCreators";
import {DataForUpload} from "../../../pages/pages";
import {getFlippingFlyer} from "../../../../../store";
import {downloadFile} from "../../../../../store/actionCreators/dowloadFileActionCreators";
import {getDate} from "../../../../../globals/globFunctions";

const useStyles = makeStyles(() => ({
    flyerBoxWrapper: {
        height: "230px",
        cursor: "pointer",
    },
    flyerWrapper: (props: any) => ({
        "&:hover": {
            filter: props.isXs ? "none" : "drop-shadow(3px 4px 6px rgba(0, 0, 0, 0.7))"
        }
    }),
    activeFlyer: {
        boxShadow: "0 0 0 5px #014780",
        boxSizing: "border-box",
        filter: "drop-shadow(3px 4px 6px rgba(0, 0, 0, 0.7))",
        borderRadius: "0",
        border: "none",

    },
    imageWrapperBlock: {
        minWidth: `50%`,
        width: `50%`,
        display: `flex`,
        alignItems: `center`,
        height: `100%`
    },
    imageWrapper: {
        width: `100%`,
        height: `100%`,
        maxWidth: `100%`,
        maxHeight: `100%`,
        padding: `4px`
    },
    flyerDescription: {
        flex: `1 1 auto`,
        '& > .MuiTypography-root': {
            lineHeight: `2`,
            fontSize: "14px"
        }
    },
    flyerDetailWrapper: {
        flex: `1 1 auto`,
        display: `flex`,
        flexFlow: `column`,
        height: `100%`,
        padding: `8px 2px`,
        width: `50%`,
        maxWidth: `50%`
    },
    controlsFlyerWrapper: {
        display: `flex`,
        columnGap: `10px`,
        position: "relative"
    },
    openBtn: {
        '&.MuiButton-root': {
            backgroundColor: `#ffffff`,
            border: '2px solid #014780',
            // background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
            display: `flex`,
            alignItems: `center`,
            padding: `4px 8px`,
            justifyContent: `center`,
            borderRadius: `0`,
            '&:hover': {
                border: '2px solid #014780B3',
                backgroundColor: `#01478030`,
            }
        }
    },
    controlBtn: {
        '&.MuiButton-root': {
            backgroundColor: `transparent`,
            // background: `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
            display: `flex`,
            alignItems: `center`,
            padding: `0`,
            justifyContent: `center`,
            "&:hover": {
                backgroundColor: `#01478030`,
            },
            '&:disabled': {
                backgroundColor: `#e4e4e480`,
            }
        }

    },

}));

interface FlyerItem {
    flyerDto: FlyerDto;
    openFlyerDetails: (rowIndex: number, flyerDto: FlyerDto) => void;
    isActive: boolean;
    flyersState: FlyersStateDto,
    setFlyerState: (e: FlyersStateDto) => void
    flyerIndex: number;
    onSoftDeleteFlyer: (ids: number[] | []) => void;
    setActionIds: (ids: number[] | []) => void;
    onArchiveFlyer: (ids: number[] | []) => void;
    onAddNewButtonClick: () => void;
    doubleClickOnFlyer: (flyerDto: FlyerDto) => void;
    setDisabledStatus: (isDisabled: boolean) => void;
    isDisabledOptionBeforeFlyerWillBeReady: boolean;
    lastSelectedFlyer?: FlyerDto;
    setShowModal: (value: boolean) => void;
    setIsShouldCheckCurrentFlyerStateBeforeLeave: (value: boolean) => void;
    setFlyersForHold: (flyers: FlyerDto[]) => void;
    columnNumbersWidth: number;
}

export const Flyer: React.FC<FlyerItem> = (props) => {
    // const dispatch = useDispatch();
    // let flyerDetailsState = useTypedSelector((state) =
    const anchorRefForFlyerMenu = useRef(null);
    const dispatch = useDispatch();
    const changedStateForFlyer = useTypedSelector((state) => state.changedStateForFlyer);
    // const [tooltip, setTooltip] = useState('');
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const [showAnalyticsPopup, setShowAnalyticsPopup] = useState<boolean>(false);
    const [isExpired, setIsExpired] = useState<boolean>(false)
    const [isOpenedFlyerMenu, setOpenFlyerMenu] = useState(false);
    const prevOpenFlyerMenu = useRef(isOpenedFlyerMenu);
    const isXs = useMediaQuery(`(max-width:699px)`)
    const [isModalPopup, changeModalStatus] = useState(false);
    const [modalName, setModalName] = useState('');

    const [filesDataForRequest, setFilesDataForRequest] = useState<DataForUpload>({
        Images: [{}],
        Pages: [],
        UiLanguageCultureCode: 'en-US'
    });
    const [thumbnailImg, setThumbnailImg] = useState<string>("");


    const properties = {
        isXs: isXs
    }
    const classes = useStyles(properties);


    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);
    const isAccountTier1 = userDto.accountTier === 1;

    const bind = useDoubleTap((event: React.MouseEvent<HTMLElement>) => {
        const target = event.target as HTMLElement;
        const tagName = target.tagName;
        if (tagName !== "INPUT") {
            handleDoubleClick();
        }
        // Your action here
    });


/*
    useEffect(() => {
        setTooltip(`Job Code: ${props.flyerDto.flyCode}
        Number of Pages: ${props.flyerDto.flyerPages?.length}
        Flyer Status: ${props.flyerDto.flyFstRec?.fstCaption}
        Start Date: ${moment(props.flyerDto.flyValidFromUtc).format('DD MMM YYYY')}
        End Date: ${moment(props.flyerDto.flyValidToUtc).format('DD MMM YYYY')}
        Created Date: ${moment(props.flyerDto.flyCreatedUtc).format('DD MMM YYYY')}
        Last Modified: ${moment(props.flyerDto.flyModifiedUtc).format('DD MMM YYYY')}`)
    });
*/

    useLayoutEffect(() => {
        const scrollPosition = sessionStorage.getItem("activeFlyersArray");
        const contentDiv = document.getElementById("flyersContentContainer");
        if (scrollPosition && contentDiv) {
            const elem = document.getElementById(scrollPosition);
            if(elem){
                elem.scrollIntoView();
                sessionStorage.removeItem("activeFlyersArray");
            }
            // contentDiv.scrollTo(0, parseInt(scrollPosition));
        }
    }, [props.isActive]);

    useEffect(() => {
        const imageUrl = props?.flyerDto?.flyerPages!.length ? (props?.flyerDto?.flyerPages[0].flyImageThumbnailUrl ? props?.flyerDto?.flyerPages[0].flyImageThumbnailUrl : '') : '';
        setThumbnailImg(imageUrl);
        const validUntil = getDate(props.flyerDto.flyValidToUtc);
        if(validUntil){
            setIsExpired(new Date() > validUntil);
        }
    }, [props.flyerDto]);

    let timer: any = 0;
    let delay = 350;
    let prevent = false;

    const clickMenuDataForFlyer: ItemsListMenuDto = {
        setOpen: setOpenFlyerMenu,
        prevOpen: prevOpenFlyerMenu,
        open: isOpenedFlyerMenu,
        anchorRef: anchorRefForFlyerMenu,
    };

    const doClickAction = (e: React.MouseEvent<HTMLElement>) => {
        const target = e.target as HTMLElement;
        const tagName = target.tagName;
        const isMenuOption = target.classList.contains("menuOption");
        dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_CREAT_NEW_FLYER, false);
        const activeFlyer = props.flyersState.activeFlyers.find((activeFlyer: FlyerDto) => activeFlyer.flyRecId === props.flyerDto.flyRecId);
        if (!activeFlyer || props.flyersState.activeFlyers.length > 1) {
            if (e.ctrlKey || e.metaKey || e.shiftKey && props.lastSelectedFlyer) {
                if (e.ctrlKey || e.metaKey) {
                    if (props.isActive) {
                        const activeFlyers = props.flyersState.activeFlyers.filter((activeFlyer: FlyerDto) => {
                            if (props.flyerDto.flyRecId !== activeFlyer.flyRecId) {
                                return activeFlyer
                            }
                        });
                        if (changedStateForFlyer.isChangedFlyerData) {
                            props.setIsShouldCheckCurrentFlyerStateBeforeLeave(true);
                            props.setFlyersForHold(activeFlyers);
                        } else {
                            props.setFlyerState({
                                ...props.flyersState,
                                activeFlyers: activeFlyers,
                                lastActivatedFlyer: props.flyerDto
                            })
                        }
                    } else {
                        const activeFlyers = [...props.flyersState.activeFlyers, props.flyerDto];
                        if (changedStateForFlyer.isChangedFlyerData) {
                            props.setIsShouldCheckCurrentFlyerStateBeforeLeave(true);
                            props.setFlyersForHold(activeFlyers);
                        } else {
                            props.setFlyerState({
                                ...props.flyersState,
                                activeFlyers: activeFlyers,
                                lastActivatedFlyer: props.flyerDto
                            })
                        }
                    }
                }
                if (e.shiftKey && props.lastSelectedFlyer && props?.flyerDto) {
                    const selection = document.getSelection();
                    selection!.removeAllRanges();
                    const isSelectedFlyerIndexBiggerOrEqualThanLastSelectedFlyerIndex = props?.flyerDto?.index! >= props?.lastSelectedFlyer?.index!;
                    const activeFlyers = props.flyersState.flyersData.filter((flyer: FlyerDto, index: number) => {
                        if (isSelectedFlyerIndexBiggerOrEqualThanLastSelectedFlyerIndex) {
                            if (props?.lastSelectedFlyer?.index! <= index && props?.flyerDto?.index! >= index) {
                                return flyer;
                            }
                        } else {
                            if (props?.lastSelectedFlyer?.index! >= index && props?.flyerDto?.index! <= index) {
                                return flyer;
                            }
                        }
                    })

                    if (changedStateForFlyer.isChangedFlyerData) {
                        props.setIsShouldCheckCurrentFlyerStateBeforeLeave(true)
                        props.setFlyersForHold(activeFlyers)
                    } else {
                        props.setFlyerState({
                            ...props.flyersState,
                            activeFlyers: activeFlyers
                        })
                    }
                }
            } else {
                // dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_TITLE_HEADER_DATA_CHANGE, props.flyerDto.flyCaption);
                // dispatchEventDataType<string | undefined>(EVENT_DATA_TYPE_DISABLE_TABS, false);
                hideMenu();
                if (tagName !== "BUTTON" && tagName !== "LABEL" && tagName !== "SELECT" && tagName !== "INPUT" && tagName && !isMenuOption) {
                    if (changedStateForFlyer.isChangedFlyerData) {
                        props.setIsShouldCheckCurrentFlyerStateBeforeLeave(true);
                        props.setFlyersForHold([props.flyerDto]);
                    } else {
                        props.setFlyerState({
                            ...props.flyersState,
                            activeFlyers: [props.flyerDto],
                            lastActivatedFlyer: props.flyerDto
                        });
                        props.setDisabledStatus(true);
                    }
                }
            }
        }
    }
    const doDoubleClickAction = () => {
        console.log('double click');
        if (!isAccountTier1) {
            if (changedStateForFlyer.isChangedFlyerData) {

            } else {
                props.doubleClickOnFlyer(props.flyerDto);
            }
        }
    }
    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        // if (e.button !== 2) {
        //     timer = setTimeout(function () {
        //         if (!prevent) {
        //             // doClickAction(e)
        //         }
        //         prevent = false;
        //     }, delay);
        // } else {
        if (!isXs) {
            doClickAction(e);
        }
        // }
    }

    const handleThumbnailClick = (e: React.MouseEvent<HTMLElement>) => {
        if (isXs) {
            e.preventDefault();
            editFlyerFromMobile();
        }

    }
    const handleDoubleClick = () => {
        clearTimeout(timer);
        prevent = true;
        doDoubleClickAction();
    }

    const handleOpenFlipbook = () => {
        window.open(`${envManager.flyerAppAddress}/${props.flyerDto.flyFltRec?.fltCode === 1 ? "flipbook" : "flyer"}/${userDto.company}/${props.flyerDto.flyCaption?.trim()}`, 'urlFromFlippingEditorScreen');
    };

    const handleAnalyticsClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setShowAnalyticsPopup(!showAnalyticsPopup);
        setAnchorEl(event.currentTarget);
        // history.push(`/flipbookEditor/${flyer.flyRecId}`)
    };

    /*
        const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
            setAnchorEl(event.currentTarget);
        };
    */

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDeleteClick = () => {
        props.setShowModal(true);
        const isCurrentFlyerIsSelect = props.flyersState.activeFlyers.some((flyer: FlyerDto) => flyer.flyRecId === props.flyerDto.flyRecId);
        if (isCurrentFlyerIsSelect && props.flyersState.activeFlyers) {
            props.setActionIds([]);
        } else {
            props.setActionIds([props.flyerDto.flyRecId!]);
        }
        // history.push(`/flipbookEditor/${flyer.flyRecId}`)
    };

    const softDeleteFlyer = () => {
        handleClose();
        const isCurrentFlyerIsSelect = props.flyersState.activeFlyers.some((flyer: FlyerDto) => flyer.flyRecId === props.flyerDto.flyRecId);
        if (isCurrentFlyerIsSelect && props.flyersState.activeFlyers.length) {
            props.setActionIds([]);
            props.onSoftDeleteFlyer([]);
        } else {
            const id = props.flyerDto.flyRecId!;
            props.setActionIds([id]);
            props.onSoftDeleteFlyer([id]);

        }
    }

    const archiveFlyer = () => {
        handleClose();
        const isCurrentFlyerIsSelect = props.flyersState.activeFlyers.some((flyer: FlyerDto) => flyer.flyRecId === props.flyerDto.flyRecId);
        if (isCurrentFlyerIsSelect && props.flyersState.activeFlyers.length) {
            props.setActionIds([]);
            props.onArchiveFlyer([]);
        } else {
            const id = props.flyerDto.flyRecId!;
            props.setActionIds([id]);
            props.onArchiveFlyer([id]);
        }
    }

    const downloadFlyer = () => {
        handleClose();
        if(props.flyerDto.flyRecId && props.flyerDto.flyDisplayCaption){
            dispatch(downloadFile(props.flyerDto.flyRecId, props.flyerDto.flyDisplayCaption));
        }
    }

    const checkIfSomeOfSelectedFlyerIsAlreadyPublished = (): boolean => {
        const currentFlyerInSelectedArray = props.flyersState.activeFlyers.find((flyer: FlyerDto) => flyer.flyRecId === props.flyerDto.flyRecId);
        if (currentFlyerInSelectedArray && props.flyersState.activeFlyers.length) {
            return props.flyersState.activeFlyers.some((flyer: FlyerDto) => flyer.flyFstRec?.fstCode === 3);
        } else {
            return props.flyerDto?.flyFstRec?.fstCode === 3
        }
    }

    const handleToggleForFlyer = () => {
        setOpenFlyerMenu((prevOpen) => !prevOpen);
    };

    const confirmUploadImageToPage = () => {
        dispatch(uploadImagesToPages(filesDataForRequest));
        dispatch(startUploadingImagesProgressPopup());
        changeModalStatus(false);
    }


    const onAddImageFilesToPages = (event: React.ChangeEvent<HTMLInputElement>) => {
        handleClose();
        const files = event.target.files!;
        const pagesInFlyer = props.flyerDto.flyerPages!;
        const imagesArray = [];
        let isOnlyImages = true;
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            imagesArray?.push({
                flpCaption: "",
                flpDisplayCaption: "",
                flpImage: file.name,
                file: file
            });
            if (file.type === 'application/pdf') {
                isOnlyImages = false;
            }
        }
        const data = {
            Images: imagesArray,
            UiLanguageCultureCode: 'en-US',
            Pages: pagesInFlyer
        }
        const itPagesHasThumbnails = pagesInFlyer?.some((key: FlyerPageDto) => key.flyImageThumbnailUrl && key.flyImageThumbnailUrl.indexOf('jpg') > -1);
        if (imagesArray.length > pagesInFlyer.length || imagesArray.length !== pagesInFlyer.length && isOnlyImages) {
            changeModalStatus(true);
            setModalName('uploadImagesToPageNotEqualSelectedPages');
        } else {
            if (itPagesHasThumbnails) {
                setFilesDataForRequest(data);
                changeModalStatus(true);
                setModalName('uploadImageToPage');
            } else {
                dispatch(startUploadingImagesProgressPopup());
                dispatch(uploadImagesToPages(data))
            }
        }
    }

    const editFlyerFromMobile = () => {
        handleClose();
        dispatch(getFlippingFlyer(props.flyerDto.flyRecId!));
        history.push(`flyersCatalog/flyerId/${props.flyerDto.flyRecId}`)
    }


    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const settings = {
        typeStatus: 0,
        title: '',
        subTitle: '',
        messages: [],
        modalName: modalName,
        confirmOnClick: {
            onUploadImage: confirmUploadImageToPage
        }
    };

    let settingsForPopup = getSettingsForPopup(settings);


    return (
        <>
            <Grid item xs={props.columnNumbersWidth} data-index={props?.flyerDto.index}
                  id={`flyer${props.flyerDto.flyRecId}`}
                  onMouseDown={handleClick}
                  className={`${classes.flyerBoxWrapper}`}

                // onDoubleClick={handleDoubleClick}
                  {...bind}
            >
                <Box
                    className={`${classes.flyerWrapper} ${props.isActive ? classes.activeFlyer : ''}`}
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexFlow: "row",
                        border: "1px solid #d3d3d3",
                        backgroundColor: props.flyerDto?.flyFstRec?.fstCode === 3 ? "#F2FFF6" : isExpired ? "#E4E4E4" : "#ffffff",
                    }}>
                    <Box
                        onClick={handleThumbnailClick}
                        className={classes.imageWrapperBlock}
                    >
                        <Box
                            className={classes.imageWrapper}
                        >
                            <AsyncImageWithLoader src={thumbnailImg} withBorders={true}/>
                        </Box>
                    </Box>
                    <Box
                        className={classes.flyerDetailWrapper}
                    >
                        <Box className={classes.flyerDescription}>
                            <Typography fontWeight={`700`}
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: "2",
                                    WebkitBoxOrient: "vertical",
                                }}
                            >{props.flyerDto.flyDisplayCaption}</Typography>
                            <Typography color={`#808080`}
                                        noWrap>Status: {isExpired ? "Expired" : props.flyerDto.flyFstRec?.fstCaption}</Typography>
                            <Typography color={`#808080`} noWrap>Pages: {props.flyerDto.flyerPages?.length}</Typography>
                            <Typography color={`#808080`} noWrap>Start
                                date: {moment(props.flyerDto.flyValidFromUtc).format('DD.MM.YY')}</Typography>
                            <Typography color={`#808080`} noWrap>End
                                date: {moment(props.flyerDto.flyValidToUtc).format('DD.MM.YY')}</Typography>
                        </Box>
                        <Box
                            className={classes.controlsFlyerWrapper}
                        >
                            <Button className={classes.openBtn} onClick={handleOpenFlipbook}>
                                <Typography color={`#014780`} mx={`5px`} fontSize={"14px"} fontWeight={700} lineHeight={1} sx={{pointerEvents: "none"}}>Open</Typography>
                            </Button>
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    columnGap: "8px",
                                    right: "0px",
                                }}
                            >
                                <Box sx={{
                                    display: `flex`,
                                    position: `relative`
                                }}>
                                    <Button className={classes.controlBtn} onClick={handleAnalyticsClick} title="Analytics"
                                            aria-describedby={id}>
                                        <AnalyticsIcon style={{pointerEvents: "none"}}/>
                                    </Button>
                                    <Popover
                                        PaperProps={{
                                            style: {
                                                borderRadius: `6px`
                                            }
                                        }}
                                        sx={{
                                            margin: `5px 0`,
                                        }}
                                        id={id}
                                        open={open}
                                        anchorEl={anchorEl}
                                        onClose={handleClose}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                    >
                                        <AnalyticsPopup setShowAnalyticsPopup={setShowAnalyticsPopup}
                                                        closePopup={handleClose}
                                                        flyerData={props.flyerDto!}/>
                                    </Popover>
                                </Box>
                                <Button
                                    sx={{
                                        width: "24px",
                                        height: "24px",
                                        opacity: props.isDisabledOptionBeforeFlyerWillBeReady ? "0.2" : "1",
                                        "&:hover": {
                                            backgroundColor: "#88888833"
                                        }
                                    }}
                                    // disableRipple={true}
                                    ref={anchorRefForFlyerMenu}
                                    aria-controls={
                                        isOpenedFlyerMenu
                                            ? "menu-list-grow"
                                            : undefined
                                    }
                                    aria-haspopup="true"
                                    onClick={handleToggleForFlyer}
                                    disabled={props.isDisabledOptionBeforeFlyerWillBeReady}
                                >
                                    <MenuOnHover style={{pointerEvents: "none"}}/>
                                </Button>
                                <MenuForPromotion
                                    list={clickMenuDataForFlyer}
                                    handleDeleteClick={softDeleteFlyer}
                                    // handleDeleteClick={userDto.accountTier === 1 ? handleDeleteClick : softDeleteFlyer}
                                    archiveFlyer={archiveFlyer}
                                    infoForMenu={`menuForFlyer`}
                                    isDisableUpload={props.flyersState.activeFlyers.length !== 1 && !isXs}
                                    isDisableDelete={checkIfSomeOfSelectedFlyerIsAlreadyPublished()}
                                    onAddImageFilesToPages={onAddImageFilesToPages}
                                    editFlyerFromMobile={editFlyerFromMobile}
                                    downloadFlyer={downloadFlyer}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Grid>

            {isModalPopup && <StatusPopup
                settings={settingsForPopup}
                type={StatusPopupType.INFO}
                title={'INFO'}
                subTitle={''}
                messages={[settingsForPopup.messages]}
                show={isModalPopup}
                handleClose={() => changeModalStatus(false)}
            />}

        </>
    )
}